import { el, mount, type RedomComponent } from "redom"
import { updateToPost } from "../helpers/collapse.js"
import { Audio } from "./audioplayer.js"

export class SectionTitle implements RedomComponent{
    tableName: HTMLHeadingElement = el("h6.subHead", { style: { textAlign: "left" } })
    col: HTMLTableColElement = el("col.col.me-auto", this.tableName)
    row: HTMLTableRowElement = el("tr.row", this.col)
    border: HTMLHeadingElement= el("h3.border-bottom noMargin");
    el = el("section-title", this.row, this.border)
    addAutoplay() {
        const circle = el("input#autoplay", { type: "checkbox" })
        if (Audio.isAutoPlay()) circle.setAttribute("checked", "")
        circle.onclick = Audio.toggleAutoPlay
        const toggler =
            el(".col-auto", { style: "padding:5px 0" },
                el("label.switch", { style: "margin:0 10px 0 5px" },
                    circle,
                    el(".slider round")
                )
            )
        const autoPlay =
            el(".col-auto", { align: "right", style: "padding:5px" },
                el("#autoPlayText.vertical-center-in-div", { style: "font-size:0.65rem", innerText: "AUTO PLAY" })
            )
        mount(this.row, autoPlay)
        mount(this.row, toggler)
    }
    private addPlayAll(fileId: string, playlist: string) {
        if (fileId && playlist) {
            const playAll = el(".col-auto", el("p.playall clickable", { innerText: "PLAY ALL", onclick: () => updateToPost(fileId, playlist) }))
            mount(this.row, playAll)
        }
    }
    updateTitle(sectionTitle: string, border: boolean = false) {
        this.tableName.innerText = sectionTitle
        if (!border) this.border.style.display = "none"
    }
    updatePlayAllTitle(sectionTitle: string, fileId: string, playlist: string, border: boolean) {
        this.addPlayAll(fileId, playlist)
        this.updateTitle(sectionTitle, border)
    }
}
